// extracted by mini-css-extract-plugin
export default {"InputGroup":"InputGroup_InputGroup__Q1Ayt","FormInput":"InputGroup_FormInput__6Xs8a","Label":"InputGroup_Label__WIvHK","RequiredBox":"InputGroup_RequiredBox__iVqax"};